/** @jsxImportSource @emotion/react */
import Color from 'color'
import { useMemo } from 'react'
import { Button, ButtonExtendedProps } from 'grommet'
import { FormClose } from 'grommet-icons'
import { CSSObject } from '@emotion/react'

export type ChipProps = ButtonExtendedProps & {
  chipColor?: string
  showCloseIcon?: boolean
}
export default function Chip({
  chipColor = '#7f48b7',
  showCloseIcon = false,
  ...props
}: ChipProps) {
  const colorInfo = useMemo(() => new Color(chipColor), [chipColor])
  const textColor = useMemo(() => (colorInfo.isDark() ? 'white' : 'black'), [colorInfo])
  const chipStyle = useMemo<CSSObject>(
    () => ({
      display: 'inline-block',
      borderRadius: '2rem',
      backgroundColor: colorInfo.hex(),
      paddingLeft: '.5rem',
      paddingBottom: showCloseIcon ? undefined : '.25rem',
      paddingTop: showCloseIcon ? undefined : '.25rem',
      paddingRight: showCloseIcon ? '.1rem' : '.5rem',
      '&:hover': {
        backgroundColor: colorInfo.saturate(0.3).hex(),
        opacity: 0.8,
      },
    }),
    [colorInfo, showCloseIcon],
  )

  return (
    <Button
      plain
      reverse
      gap="none"
      size="small"
      margin=".25rem"
      css={chipStyle}
      color={textColor}
      icon={showCloseIcon ? <FormClose color={textColor} /> : undefined}
      {...props}
    />
  )
}
